export interface Role {
  id: number;
  data_type: "Default data" | "User data";
  role_name: string;
  display_role_name: string | null;
}

export const mapRole = (data: any): Role => {
  if (!data) {
    throw new Error("Invalied Role type");
  }

  const uesrRole: Role = {
    id: data.id,
    data_type: data.data_type,
    role_name: data.role_name,
    display_role_name: data.display_role_name,
  };

  return uesrRole;
};

export const mapRoles = (data: any[]): Role[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Role data");
  }

  return data.map(mapRole);
};
